// extracted by mini-css-extract-plugin
export var avatarContainer = "_7l-1";
export var largeAvatarContainer = "_7l-2";
export var smallAvatarContainer = "_7l-0";